<div class="row">
    <div class="col" *ngIf="!isAddFile">
        <button type="button" class="btn btn-primary" (click)="addDocument()">Add Document</button>
    </div>
    <div class="col-sm-6" *ngIf="isAddFile">
        <label class="fw-bold">Document Type</label>
        <select name="documentType" [(ngModel)]="newDocumentTypeID" class="form-select" required>
            <option *ngFor="let docType of documentTypeList" value="{{docType.documentTypeID}}">{{docType.documentTypeName}}</option>
        </select>
    </div>
    <div class="col" *ngIf="isAddFile && newDocumentTypeID > 0">
        <input type="file" id="file{{newDocumentTypeID}}" (change)="uploadFile($event, newDocumentTypeID)" />
        <button type="button" class="btn btn-secondary" (click)="cancelAddDocument()">Cancel</button>
    </div>
</div>
<div class="row">
    <div [ngClass]="isBatch ? 'col-sm-9' : 'col-sm-12'">
        <kendo-grid #filesGrid
                    [data]="gridData"
                    [sortable]="false"
                    [pageable]="false"
                    [filterable]="false"
                    [resizable]="isBatch">
            <kendo-grid-column field="documentTypeID" title="Action" width="140">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div style="white-space:nowrap;">
                        <a [routerLink]="" class="text-primary" (click)="viewFile(dataItem)" *ngIf="dataItem.blobFileID > 0"><i class="fas fa-eye fa-lg p-1"></i></a>
                        <a [routerLink]="" class="text-primary" (click)="downloadFile(dataItem)" *ngIf="dataItem.blobFileID > 0"><i class="fas fa-download fa-lg p-1"></i></a>
                        <a [routerLink]="" class="text-danger" (click)="deleteFile(dataItem)" *ngIf="canDeleteFile(dataItem)"><i class="fas fa-times fa-lg p-1"></i></a>
                        <label for="file{{dataItem.documentTypeID}}" *ngIf="dataItem.blobFileID == 0" style="cursor:pointer"><i class="fas fa-cloud-upload-alt fa-lg p-1"></i></label>
                        <form style="display:none;"><input type="file" id="file{{dataItem.documentTypeID}}" (change)="uploadFile($event, dataItem.documentTypeID)" /></form>
                        <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="editBatch(dataItem)" *ngIf="dataItem.documentTypeAbbrev == 'Combined' && dataItem.blobFileID > 0"><i class="fas fa-pencil-alt"></i></button>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="documentTypeName" title="Document Type"></kendo-grid-column>
            <kendo-grid-column field="isRequired" title="Required?" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="checkbox" [checked]="dataItem.isRequired" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="fileName" title="File"></kendo-grid-column>
            <kendo-grid-column field="fileDescription" title="Description"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-3" *ngIf="isBatch">
        <div class="row">
            <div class="col">
                <button type="button" class="btn btn-secondary float-end" (click)="closeEditBatch()"><i class="fas fa-times"></i></button>
            </div>
        </div>
        <div class="row" *ngFor="let docType of documentTypeList;let idx = index;">
            <div class="col">
                <div *ngIf="docType.documentTypeAbbrev != 'Combined'">
                    <input type="checkbox"
                           id="docType{{docType.documentTypeID}}"
                           name="docType{{docType.documentTypeID}}"
                           style="transform: scale(1.5); margin: 5px;"
                           (change)="saveBlobFileBatch(docType, $event)"
                           [checked]="isBlobFileBatchChecked(docType)"
                           required />
                    <label for="docType{{docType.documentTypeID}}">{{docType.documentTypeName}}</label>
                    <!--[(ngModel)]="blobFileBatchList[idx].blobFileID > 0"-->
                </div>
            </div>
        </div>
    </div>
</div>

<document-viewer [fileName]="docViewerFileName" [fileUri]="docViewerFileUri" (onClose)="viewFile({})"></document-viewer>
